
export const StageUrlsMap = {
  REACT_APP_REST_API_URL: `https://stage-core.stwin2025.co/api/v1`,
  TOKEN_URL: `https://stage-core.stwin2025.co`,
  SAP_CATALOG: `https://stage-catalog.mysportsfeed.io/api`,
  SAP_API: `https://stage-api.mysportsfeed.io/api/v1`,
  BONUS_API: `https://stage-bonus-api.stwin2025.co/api/v1`,
  INDIGO_API: `https://stage-catalog.king18.co/`,
  OCR_API: 'https://stage-ocr.stwin2025.co',
  RANDORA_API: `https://stage-prolite.stwin2025.co/api/v1`
};

export const ProdUrls = {
  REACT_APP_REST_API_URL: `https://core.stwin2025.co/api/v1`,
  TOKEN_URL: `https://core.stwin2025.co`,
  SAP_CATALOG: `https://scatalog.mysportsfeed.io/api`,
  SAP_API: `https://api.mysportsfeed.io/api/v1`,
  BONUS_API: `https://bonus-api.stwin2025.co/api/v1`,
  INDIGO_API: `https://catalog.king18.co/`,
  OCR_API: 'https://ocr.stwin2025.co',
  RANDORA_API: `https://prolite.stwin2025.co/api/v1`
};

export const EnvUrlsMap: { [key: string]: any } = {
  stage: StageUrlsMap,
  production: ProdUrls,
};

export function getBaseUrl(env: any, url: string) {
  return EnvUrlsMap[env][url];
}
